/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	DiplomaStudentDTO,
	DiplomaStudentDTOFromJSON,
	DiplomaStudentDTOFromJSONTyped,
	DiplomaStudentDTOToJSON,
} from "./DiplomaStudentDTO";

/**
 *
 * @export
 * @interface DiplomaStudentDTOPagedResponse
 */
export interface DiplomaStudentDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof DiplomaStudentDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof DiplomaStudentDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof DiplomaStudentDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<DiplomaStudentDTO>}
	 * @memberof DiplomaStudentDTOPagedResponse
	 */
	data?: Array<DiplomaStudentDTO> | null;
}

export function DiplomaStudentDTOPagedResponseFromJSON(
	json: any
): DiplomaStudentDTOPagedResponse {
	return DiplomaStudentDTOPagedResponseFromJSONTyped(json, false);
}

export function DiplomaStudentDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): DiplomaStudentDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(DiplomaStudentDTOFromJSON),
	};
}

export function DiplomaStudentDTOPagedResponseToJSON(
	value?: DiplomaStudentDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(DiplomaStudentDTOToJSON),
	};
}
